import React from "react"

import WrapPage from "../components/wrapPage"
import Skills from "./skills"

export default props => (
  <>
    <Skills {...props} />
  </>
)
